export default "__VITE_ASSET__Ekh_rW7dAR6uL_8ap9NdGQ__"